"use server";

import type { WorkspaceCapabilityOverview } from "../companyCapabilities.types";

import {
  FetchResponseWrapper,
  fetchWithAuth,
} from "@/modules/common/fetch/fetchWithAuth";

export const getCurrentWorkspaceCapabilities = async (): Promise<
  FetchResponseWrapper<WorkspaceCapabilityOverview>
> =>
  fetchWithAuth<WorkspaceCapabilityOverview>({
    endpoint: "/company-capabilities/current",
  });

export const getAdminWorkspaceCapabilities = async (
  companyId: number,
): Promise<FetchResponseWrapper<WorkspaceCapabilityOverview>> =>
  fetchWithAuth<WorkspaceCapabilityOverview>({
    endpoint: `/company-capabilities/admin/${companyId}`,
  });
